import React from "react";
import { useTV } from "../../../hooks/useTV";
import MultiViewLandingDisplay from "./MultiViewLandingDisplay/MultiViewLandingDisplay";
import MultiViewLandingTV from "./MultiViewLandingTV/MultiViewLandingTV";
import VipSubCheck from "../VIP/VipSubCheck";

const MultiViewLanding = () => {
  const { isTv } = useTV();
  return (
    <>
      {isTv ? <MultiViewLandingTV /> : <MultiViewLandingDisplay />}
      <VipSubCheck />
    </>
  );
};

export default MultiViewLanding;
